import { render, staticRenderFns } from "./IncidentRiskTypesPage.vue?vue&type=template&id=f74e16ce"
import script from "./IncidentRiskTypesPage.vue?vue&type=script&lang=js"
export * from "./IncidentRiskTypesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports